module.exports = __webpack_public_path__ + "static/media/lateral zones.96af0f06.png";